<template>
    <div class="container">
        <div class="row" v-if="!seccion_seleccionada">
            <div class="col-12">
                <h2 class="m-0 h1 text-uppercase text-center pb-3">{{ $t('partido.pinchando_mapa') }}</h2>
            </div>

            <div class="col-12" v-show="!paso1_loading">
                <transition name="fade" mode="out-in">
                    <div class="row" key="secciones" id="zonas">
                        <div class="col-lg-12">
                            <div class="lightgray-content">
                                <SvgSectionsComponent
                                    :event="event"
                                    :sesion_id="sesion_id"
                                    :secciones="secciones"
                                    @clickZona="seccionSeleccionada"
                                    @cargado="paso1_loading = false"
                                />												
                            </div>
                        </div>
                    </div>
                </transition>
            </div>
            <div v-if="paso1_loading" class="col-12 text-center" style="height: 400px">
                <LoaderComponent/>
            </div>
        </div>
        <div class="row" v-else>
            <template v-if="! seccion_seleccionada.tiene_secciones">
                <div class="col-12 justify-content-between d-flex">
                    <span class="m-0 h1 text-uppercase">{{ $t('partido.selecciona_entradas', { entradas: footer.termino_entradas }) }}</span>
                    <button @click="volver" class="h6 button small-button m-0"><i class="fa fa-redo"></i> Volver</button>
                </div>

                <b-col cols="12" class="pt-3">
                    <b-breadcrumb>
                        <b-breadcrumb-item 
                            v-for="(item, index) in breadcrumbs" 
                            :key="index" 
                            @click="breadcrumbs.length -1 == index ? null : goTo(item, index)"
                            :active="breadcrumbs.length -1 == index"
                        >
                            {{ item.name }}
                        </b-breadcrumb-item>
                    </b-breadcrumb>
                </b-col>

                <div class="col-12" v-show="!paso1_loading">
                    <transition name="fade" mode="out-in">
                        <div class="row" key="seccion" id="zonas"> 
                            <b-col cols="12">
                                <h3 class="subtitle h3 light mb-3 ">A) {{ $t('partido.pinchando_mapa') }}:</h3>
                            </b-col>
                            <div class="col-lg-8" v-if="!loading_zonas">
                                <div class="lightgray-content">
                                    <SvgSectionComponent
                                        :event="event"
                                        :sesion_id="sesion_id"
                                        :zonas="zonas_formated"
                                        :seccion="seccion_seleccionada"
                                        @clickZona="finalizarPasoUno"
                                        @cargado="paso1_loading = false"
                                    />												
                                </div>
                            </div>
                            <div class="col-12 col-lg-4">
                                <h3 class="subtitle h3 light mb-3 ">B) {{ $t('partido.tabla') }}:</h3>
                                <div class="lightgray-content p-2 pb-0">
                                    <TablaSectoresComponent :zonas="zonas_formated" v-on:goTo="finalizarPasoUno"/>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
                <div v-if="paso1_loading" class="col-12 text-center" style="height: 400px">
                    <LoaderComponent/>
                </div>
            </template>
            <template v-else>
                <div class="col-12 justify-content-between d-flex">
                    <h2 class="m-0 h1 text-uppercase text-center pb-3">{{ $t('partido.pinchando_mapa') }}</h2>
                    <button @click="volver" class="h6 button small-button m-0"><i class="fa fa-redo"></i> Volver</button>
                </div>

                <b-col cols="12" class="pt-3">
                    <b-breadcrumb>
                        <b-breadcrumb-item 
                            v-for="(item, index) in breadcrumbs"
                            :key="index" 
                            @click="breadcrumbs.length -1 == index ? null : goTo(item, index)"
                            :active="breadcrumbs.length -1 == index"
                        >
                            {{ item.name }}
                        </b-breadcrumb-item>
                    </b-breadcrumb>
                </b-col>

                <div class="col-12" v-show="!paso1_loading">
                    <transition name="fade" mode="out-in">
                        <div class="row" key="secciones" id="zonas">
                            <div class="col-lg-12">
                                <div class="lightgray-content">
                                    <SvgSectionComponent
                                        :event="event"
                                        :sesion_id="sesion_id"
                                        :zonas="secciones"
                                        :seccion="seccion_seleccionada"
                                        @clickZona="seccionSeleccionada"
                                        @cargado="paso1_loading = false"
                                    />
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
                <div v-if="paso1_loading" class="col-12 text-center" style="height: 400px">
                    <LoaderComponent/>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import SvgSectionComponent from './SvgSectionComponent'
    import SvgSectionsComponent from './SvgSectionsComponent'
    import TablaSectoresComponent from '@/components/frontend/events/compra/TablaSectoresComponent';

    export default {
        props: {
            event: {
                type: Object,
                required: true
            },
            sesion_id: {
                type: Number,
                required: true
            },
            // Optional. The Día del Abonado flow needs the subscriber's id so the
            // region resource resolves `precios_abonados` against THEIR discount
            // (`getAllPreciosOnline($abonado_id)`) instead of the generic list.
            // The normal purchase flow never passes it, so its behaviour is
            // unchanged.
            abonado_id: {
                type: [Number, String],
                required: false,
                default: null
            }
        },
        data() {
            return {
                seccion_seleccionada: null,
                paso1_loading: true,
                secciones: null,
                breadcrumbs: [],
                loading_zonas: false,
                zonas: [],
            }
        },
        created() {
            this.breadcrumbs.push({
                name: 'Inicio'
            })
            this.getSecciones();
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            zonas_formated() {
                var array = [];
                for(var zona in this.zonas) {
                    array.push(this.zonas[zona]);
                    var disponible = array[zona].precios.length > 0 && array[zona].esta_disponible && array[zona].libres > 0 ? true : false;
                    array[zona].esta_disponible = disponible;
                }

                return array;                
            },
        },
        methods: {
            getSecciones() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    tid: this.configuracion.hash_teatro,
                    event_id: this.event.id,
                    sesion_id: this.sesion_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.evento.sesion.secciones'), params).then(res => {
                    this.secciones = res.data.data;
                })
            },
            seccionSeleccionada(seccion) {
                this.breadcrumbs.push({
                    name: seccion.name,
                    id: seccion.id,
                    tiene_secciones: seccion.tiene_secciones
                })
                this.paso1_loading = true;
                if(! seccion.tiene_secciones) {
                    this.zonas = [];
                    this.getSeccionRegiones(seccion);
                    this.getSeccionRegionesAnexas(seccion);
                } else {
                    this.getSeccionRegiones(seccion);
                }
            
                this.seccion_seleccionada = seccion;
            },
            getSeccionRegiones(seccion) {
                this.loading_zonas = true;
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        // Only appended when present, so the normal flow's query
                        // string is byte-identical to before.
                        ...(this.abonado_id ? { abonado_id: this.abonado_id } : {})
                    },
                    tid: this.configuracion.hash_teatro,
                    event_id: this.event.id,
                    sesion_id: this.sesion_id,
                    seccion_id: seccion.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.evento.sesion.secciones.seccion.regiones'), params).then(res => {
                    if(! seccion.tiene_secciones) {
                        this.zonas = this.zonas.concat(res.data.data);
                    } else {
                        this.secciones = res.data.data;
                    }
                
                }).finally(() => {
                    this.loading_zonas = false;
                });
            },
            getSeccionRegionesAnexas(seccion) {
                this.loading_zonas = true;
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        seccion_id: seccion.id
                    },
                    tid: this.configuracion.hash_teatro,
                    event_id: this.event.id,
                    sesion_id: this.sesion_id,
                    seccion_id: seccion.id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.zonas.recintos-anexos.index'), params).then(res => {
                    if(res.data.data.length > 0) {
                        this.zonas = this.zonas.concat(res.data.data);
                    }                
                }).finally(() => {
                    this.loading_zonas = false;
                });
            },
            finalizarPasoUno(zona) {
                this.$emit('terminar', zona);
            },
            volver() {
                let index = this.breadcrumbs.length -2;
                this.goTo(this.breadcrumbs[index], index)
            },
            goTo(item, index) {
                if(item.name == 'Inicio') {
                    this.reset();
                } else {
                    this.breadcrumbs.splice(index);
                    this.seccionSeleccionada(item);
                }
            },
            reset() {
                this.breadcrumbs = [{
                    name: 'Inicio'
                }];
                this.seccion_seleccionada = null;
                this.zonas = [];
                this.getSecciones();
            },
        },
        components : {
            SvgSectionComponent, SvgSectionsComponent, TablaSectoresComponent
        }
    }
</script>